import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { siteStatsBackend } from './site-stats.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { siteStatsReducer } from './site-stats.reducer';

// FIXME: remove that
backend.siteStats = siteStatsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('siteStats', siteStatsReducer),
    /* DatastoreBackendModule.forFeature(
      'siteStats',
      siteStatsBackend,
    ),*/
  ],
})
export class DatastoreSiteStatsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/site-stats/site-stats.module.ts